import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["confirmButton"]

  declare readonly urlValue: string
  declare readonly confirmButtonTarget: HTMLButtonElement

  confirmRevoke(event: Event) {
    event.preventDefault()

    const button = this.confirmButtonTarget
    const originalContent = button.innerHTML

    // Show loading state
    button.disabled = true
    button.innerHTML = `
      <span class="loading loading-spinner loading-sm"></span>
      Revoking...
    `

    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    // Submit the revoke request
    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': token || '',
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Revoke failed')
      }
    }).then(html => {
      // Close the modal
      const modal = document.getElementById('api_key_revoke_modal') as HTMLDialogElement
      if (modal) {
        modal.close()
      }

      // Process the turbo stream response to replace the row
      if (html) {
        // Create a temporary container to parse the turbo stream
        const template = document.createElement('template')
        template.innerHTML = html

        // Let Turbo handle the stream
        const turboStream = template.content.querySelector('turbo-stream')
        if (turboStream) {
          document.body.appendChild(turboStream)
        }
      }

      // Reset button state
      button.disabled = false
      button.innerHTML = originalContent
    }).catch(error => {
      console.error('Error revoking API key:', error)
      button.disabled = false
      button.innerHTML = originalContent
      alert('Failed to revoke API key. Please try again.')
    })
  }
}
